import FormattedMessage from 'I18n/components/FormattedMessage';
import EditorScrollingBodyContainer from './EditorScrollingBodyContainer';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorEmptyStateMessage = () => {
  return /*#__PURE__*/_jsx(EditorScrollingBodyContainer, {
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      marginBlockStart: "1100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filterGroupEditor.emptyStateMessage"
      })
    })
  });
};
export default EditorEmptyStateMessage;